import { styled } from '@mui/material/styles';

export const classes = {
  leftWrapper: 'left-wrapper',
  rightWrapper: 'right-wrapper',
  circle: 'circle',
  logo: 'logo',
  AtiQxID: 'AtiQxID',
  logoMobile: 'logo-mobile',
  topbar: 'topbar',
  content: 'content',
};

export const Root = styled('div', {
  shouldForwardProp: (prop) => prop !== 'lg',
})<{ lg?: boolean }>(({ theme, lg }) => ({
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  width: '100%',
  height: '100%',

  [`& .${classes.leftWrapper}`]: {
    width: '60%',
    height: '100%',
    transition: 'all 1s',

    ...(lg && { display: 'none' }),

    [`& .${classes.circle}`]: {
      position: 'absolute',
      width: '250%',
      height: '350%',
      top: '-125%',
      right: '36%',
      borderRadius: '50%',
      boxShadow: theme.shadows[6],
      backgroundColor: theme.palette.primary.main,
      transition: 'border-radius 4s, right 1s',
      zIndex: 1,
    },
    [`& .${classes.logo}`]: {
      position: 'absolute',
      margin: theme.spacing(1),
      zIndex: 3,
    },
    [`& .${classes.AtiQxID}`]: {
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      width: '60%',
      height: '100%',
      transition: 'all 0.9s',
      zIndex: 2,
      '& #pants, #step, #shield_outer, #checkmark_circle': {
        fill: theme.palette.primary.light,
      },
      '& #key, #keyhole, #lock_ring, #foot': {
        fill: '#424242',
      },
    },
  },
  [`& .${classes.rightWrapper}`]: {
    width: '50%',
    height: '100%',
    right: 0,
    paddingLeft: '10%',
    backgroundColor: theme.palette.background.default,
    transition: 'right 0.6s',

    ...(lg && { width: '100%', padding: 0 }),
    [`& .${classes.logoMobile}`]: {
      position: 'absolute',
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: 64,
    },
    [`& .${classes.topbar}`]: {
      display: 'flex',
      width: '100%',
      height: 64,
      alignItems: 'center',
      justifyContent: 'flex-end',
      color: theme.palette.text.secondary,
      paddingRight: theme.spacing(1),
    },
    [`& .${classes.content}`]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      width: '100%',
      minWidth: 272,
      height: 'calc(100% - 64px)',
      color: theme.palette.text.secondary,
    },
  },
}));
